import React from "react";
import BorderWrapper from "../../../../components/dashboard/border-wrapper/BorderWrapper";
import HeadingSkeleton from "../../../../components/skeletons/HeadingSkeleton";


export default function PointsButtonSkeleton() {
    return(
        <div className={'points mt-4 mt-xl-0'}>
            <BorderWrapper key={1}>
                <div className={'points-earn'}>
                    <HeadingSkeleton block={true} height={20} maxWidth={100} />
                </div>
            </BorderWrapper>
            <BorderWrapper key={2}>
                <div className={'streak'}>
                    <HeadingSkeleton block={true} height={20} maxWidth={100} />
                </div>
            </BorderWrapper>
        </div>
    )
}
